import 'bootstrap'
import './modalAjax'

import './style.scss'
//import './wordpress.scss'